<template>
  <v-navigation-drawer
      :mini-variant.sync="mini"
      v-model="inputValue"
      app
      color="#14AAA6"
      dark
      floating
      class="drawerclass no-print"
      persistent
      :permanent="isLargeScreen"
      mobile-breakpoint="1070"
      width="200"
  >
    <v-list-item style="background-color: white">
      <v-list-item-content style="padding: 8px 0" class="d-flex justify-center">
        <v-img src="@/assets/logo2.png" class="rounded-lg" max-width="100"></v-img>
      </v-list-item-content>
      <v-btn
          icon
          light
          @click.stop="mini = !mini"
      >
        <v-icon small>mdi-close</v-icon>
      </v-btn>
    </v-list-item>

    <v-divider></v-divider>
    <v-list dense nav class="pl-0" style="padding-right: 12%;" shaped>
      <v-list-item
          v-for="item in filteredNavItems"
          :key="item.title"
          :to="item.route"
          active-class="active-item"
      >

        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <div class="profile-panel">
      <v-expansion-panels>
        <v-expansion-panel class="rounded-0" color="white">
          <v-expansion-panel-header>{{ loggedIn.contact.firstName }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-list dense>
              <v-list-item
                  link
                  :to="{ name: 'EditCurrentUserProfile'}"
              >
                <v-list-item-icon>
                  <v-icon>mdi-account</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>profile</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                  link
                  @click="logOut"
              >
                <v-list-item-icon>
                  <v-icon>mdi-logout</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Logout</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </v-navigation-drawer>
</template>

<script>
import {mapGetters} from 'vuex';
import {updateAbilityRules} from '@/utils/caslAbility';
import {watch} from "vue";

export default {
  data() {
    return {
      navItems: [],
      permissions: [],
      drawer: true,
      mini: false,
      loggedIn: this.$store.getters.getLoggedUser
    };
  },
  created() {
    window.addEventListener("localstorage-change", (e) => {
      this.navItems = JSON.parse(JSON.stringify(this.navItems));
    });
  },
  async mounted() {

    // const permissions = JSON.parse(localStorage.getItem('permissions') || []);
    // const currentUser = JSON.parse(localStorage.getItem('user') || 'null');
    // // if (permissions && permissions.length > 0) {
    //   this.permissions = permissions;
    this.navItems = [
      {title: "Dashboard", icon: "mdi-view-dashboard", route: "/", permission: 'dash_board_page'},
      {
        title: "Appointements",
        icon: "mdi-calendar",
        route: "/appointements",
        permission: 'appointments_page'
      },
      {
        title: "Patients",
        icon: "mdi-account-injury",
        route: "/patients",
        permission: 'patients_page'
      },
      {
        title: "Relatives",
        icon: "mdi-account-group",
        route: "/relatives",
        permission: 'relatives_page'
      },
      {title: "Settings", icon: "mdi-cog", route: "/settings", permission: 'setting_page'},
      {title: "Statistics", icon: "mdi-chart-bar-stacked", route: "/statistics", permission: 'statistics_page'},
      {title: "Reports", icon: "mdi-file-document", route: "/reports", permission: 'reports_page'},

    ]
    // }

    // updateAbilityRules(permissions, currentUser?.id);
  },


  methods: {

    logOut() {

      this.$store.dispatch('logout')
      this.$router.push({name: 'Login'})
    },


    editUser() {
      this.$router.push({name: 'EditUser', params: {id: +this.$store.getters.getLoggedUser.id}})
    }
  },
  computed: {
    ...mapGetters(['getDataFromRouterView', 'getPermissions', 'getDrawer']),
    dataFromRouterView() {
      return this.getDataFromRouterView;
    },
    isLargeScreen() {
      return this.$vuetify.breakpoint.lgAndUp;
    },
    inputValue: {
      get() {
        return this.$store.getters.getDrawer;
      },
      set(val) {
        this.$store.dispatch("setDrawerAction", val);
      },
    },
    filteredNavItems() {
      return this.navItems.filter((item) => this.$canAny([item.permission]));
    },
  },
  watch: {
    isLargeScreen(val) {
      if (val) {
        this.$store.dispatch('setDrawerAction', val)
      }
    },
    getPermissions(permissions) {
      this.$forceUpdate();
      // const currentUser = this.$store.getters.getLoggedUser;
      // updateAbilityRules(permissions, currentUser?.id);
    }
  }
};
</script>

<style scoped>

@media print {
  /* Hide elements we don't want to print */
  .no-print {
    display: none !important;
  }

}

.active-item {
  background-color: #004a4a;
  /* border-radius: 0 15px 15px 0 !important; */
}

.profile-panel .v-expansion-panels {
  position: absolute;
  bottom: 0;
}

.profile-panel .v-expansion-panel-header {
  background-color: #3d7575;
}

.profile-panel .v-expansion-panel-content__wrap {
  padding: 0;
  background-color: #458888;
}

.v-list-item__icon {
  margin-right: 12px !important;
}

.drawerclass {
  border-right: 1.5px solid #e0e0e0 !important;
}
</style>
